import { showSuccess, showError } from '@calendly/alert';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { CenteredOverlay } from '@calendly/ui/components/centered-overlay';
import { AiSparkleIcon, CloseMiniIcon } from '@calendly/ui/components/icons';
import { TitleText } from '@calendly/ui/components/typography';
import { useDispatch } from 'react-redux';
import { WistiaPlayer } from 'components/external/wistia';
import { SETTINGS_SECTION } from 'features/settings_modal/constants';
import { useSettingsNavigation } from 'features/settings_modal/use_settings_navigation';
import { useTrack } from 'hooks/analytics_events';
import { useEnableAssistant, useGetUserSchedulingAssistantEnabledSettingValue } from 'hooks/scheduling_assistant';
import { trackContinueToSetupClicked } from '../analytics';
import { titleRowCss, titleTextWrapCss } from './event_type_selection_overlay/styles';
const WISTIA_MEDIA_ID = 'y16pflxpaq';
const paddedTitleContainerCss = "p19gt0ie";
const videoSectionRootCss = "v1okf1h7";
const OverlayTitle = ({
  onDismiss
}) => <div className={paddedTitleContainerCss}>
    <div className={titleRowCss}>
      <div className={titleTextWrapCss}>
        <TitleText size="large">
          {I18n.t('publisher.home.ai_assistant_banner.watch_how_it_works_overlay.title')}
        </TitleText>
      </div>
      <BareButton type="button" decoration="ghost" onClick={onDismiss} aria-label={I18n.t('publisher.action.close')}>
        <CloseMiniIcon />
      </BareButton>
    </div>
  </div>;
const OverlayFooter = ({
  ctaKey,
  onClose,
  onContinueToSetupClick
}) => {
  const track = useTrack();
  const dispatch = useDispatch();
  const {
    enableAssistant,
    isEnabling
  } = useEnableAssistant();
  const {
    schedulingAssistantEnabledSettingValue,
    isLoading
  } = useGetUserSchedulingAssistantEnabledSettingValue();
  const callieIsEnabled = schedulingAssistantEnabledSettingValue === 'true';
  const callieIsDisabled = schedulingAssistantEnabledSettingValue === 'false';
  const callieIsNotConfigured = !callieIsEnabled && !callieIsDisabled;
  const {
    navigateToSettingsSection
  } = useSettingsNavigation();
  const handleContinueToSetupClick = () => {
    if (ctaKey) {
      trackContinueToSetupClicked(track, ctaKey);
    }
    if (onContinueToSetupClick) {
      onClose();
      onContinueToSetupClick();
      return;
    }
    setTimeout(() => navigateToSettingsSection(SETTINGS_SECTION.callie, {
      legacyPath: '/app/personal/assistant'
    }), 300);
  };
  let buttonLabel;
  let buttonClickHandler;
  if (callieIsDisabled) {
    buttonLabel = I18n.t('publisher.home.ai_assistant_banner.watch_how_it_works_overlay.enable_callie');
    buttonClickHandler = async () => {
      const outcome = await enableAssistant();
      if (outcome.noEligibleEventType) {
        dispatch(showError(I18n.t('publisher.personal_settings.scheduling_assistant.disabled.no_default_event_type')));
        return;
      }
      if (outcome.ok) {
        dispatch(showSuccess(I18n.t('publisher.personal_settings.scheduling_assistant.disabled.set_up_success')));
      } else if (outcome.error) {
        dispatch(showError(I18n.t('publisher.personal_settings.scheduling_assistant.disabled.set_up_error')));
      }
    };
  } else if (callieIsEnabled) {
    buttonLabel = I18n.t('publisher.action.done');
    buttonClickHandler = onClose;
  } else {
    // Onboarding flow where Callie is not configured yet
    buttonLabel = I18n.t('publisher.home.ai_assistant_banner.watch_how_it_works_overlay.continue_to_setup');
    buttonClickHandler = handleContinueToSetupClick;
  }
  return <Button decoration="primary" onClick={buttonClickHandler} loading={isLoading || isEnabling}>
      {callieIsNotConfigured && <AiSparkleIcon />}
      {buttonLabel}
    </Button>;
};
export const WatchHowItWorksOverlay = ({
  ctaKey,
  onClose,
  onDismiss,
  onContinueToSetupClick
}) => <CenteredOverlay isOpen onClose={onDismiss} hasPadding={false} title={<OverlayTitle onDismiss={onDismiss} />} footer={<OverlayFooter ctaKey={ctaKey} onClose={onClose} onContinueToSetupClick={onContinueToSetupClick} />}>
    <div className={videoSectionRootCss}>
      <WistiaPlayer videoId={WISTIA_MEDIA_ID} loop={false} />
    </div>
  </CenteredOverlay>;

require("./watch_how_it_works_overlay.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./watch_how_it_works_overlay.js");